import React, { Component } from 'react'
import { pink, green, maxwidth } from '../../constants'
import FocusSlider from '../Focus_slider/Focus_slider'
import podcast from '../../images/podcast.png'
import safetylaw from '../../images/safetylaw.png'
import safetygadgets from '../../images/gadgets.png'
import seminar from '../../images/seminar.png'
import safetyscheme from '../../images/safetyscheme.png'
import defence from '../../images/selfdefence.png'


import './Focus.css'

class Focus extends Component {
    icons = [

        {
            src: podcast,
            title: "Safety Podcast"
        },
        {
            src: safetylaw,
            title: "Safety Law"
        },
        {
            src: seminar,
            title: "Safety Seminars"
        },
        {
            src: safetygadgets,
            title: "Safety Gadgets"
        },
        {
            src: defence,
            title: "Self-Defence Training"
        },
        {
            src: safetyscheme,
            title: "Safety Scheme"
        }
       
       
    ];
  render() {
    return (
     
        <div id='focus' className='focus-outer-container'>
                    <p className='title'>Our Focus</p>

                    <div className='focus-inner-container'>
                        <div className='focus-subone'>

                            <p style={{ color: pink, fontSize: "25px", }}>Problems</p>
                            <div style={{height:"20px"}}></div>
                            <div style={{ margin: "5px" }}>
                                <FocusSlider></FocusSlider>
                            </div>

                        </div>
                        <div className='focus-subtwo'>

                            <p style={{ color: green, fontSize: "25px", }}>Solutions</p>
                            <div style={{height:"20px"}}></div>
                            <div className='grid-land'>
                                {this.icons.map((val, index) => {
                                    return <div key={index} style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "20px" }}>
                                        <div>
                                            <img src={val.src} height="120px"></img>
                                        </div>
                                        <p style={{ color: green, fontSize: "16px", textAlign: "center", fontWeight: "500", marginTop: "20px", display: "flex", justifyContent: "center" }}>
                                            {val.title}</p>

                                    </div>
                                })}
                            </div>

                        </div>
                    </div>
                
        </div>
    )
  }
}

export default Focus
